var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-card', {
    staticClass: "card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.toggleCollapse.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "pointer",
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('collapse-button', {
    attrs: {
      "is-open": _vm.isOpen
    }
  }), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._t("header")], 2), _c('div', [_vm.action ? _c('el-button', {
    attrs: {
      "type": "text",
      "icon": _vm.action.icon
    },
    on: {
      "click": _vm.action.callback
    }
  }, [_vm._v(_vm._s(_vm.action.text))]) : _vm._e()], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOpen,
      expression: "isOpen"
    }],
    staticClass: "content"
  }, [_vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }